<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 년도 -->
          <c-datepicker
            :range="true"
            type="year"
            defaultStart="0y"
            defaultEnd="0y"
            label="LBLYEAR"
            name="years"
            v-model="searchParam.years"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="개선 목록"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'musculImpr',
  data() {
    return {
      searchParam: {
        plantCd: null,
        years: [],
        stepCd: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'heaInvestigationPlanId' },
          { index: 1, colName: 'heaInvestigationPlanId' },
          { index: 2, colName: 'heaInvestigationPlanId' },
          { index: 3, colName: 'heaMuscleSopId' },
          { index: 4, colName: 'heaMuscleSopResultId' },
          { index: 5, colName: 'heaMuscleSopResultId' },
          { index: 6, colName: 'heaMuscleSopResultId' },
          { index: 7, colName: 'heaMuscleSopResultId' },
        ],
        data: [],
        columns: [],
      },
      editable: true,
      imprData: null,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.muscleSopResultImpr.list.url
      // code setting
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: false,
            style: 'width:90px',
          },
          {
            name: 'investigationPlanName',
            field: 'investigationPlanName',
            label: '조사계획명',
            align: 'left',
            sortable: false,
            style: 'width:250px',
          },
          {
            name: 'year',
            field: 'year',
            label: 'LBLYEAR',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '단위작업',
            align: 'center',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'heaAssessmentToolName',
            field: 'heaAssessmentToolName',
            label: '작업분석․평가도구',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'resultName',
            field: 'resultName',
            label: '평가결과',
            align: 'left',
            style: 'width:150px',
            sortable: false,
            type: 'html'
          },
          {
            name: 'judgment',
            field: 'judgment',
            label: '판정',
            align: 'left',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'workerOpinion',
            field: 'workerOpinion',
            label: '근로자의견',
            align: 'left',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: 'LBLTITLE',
            align: 'left',
            type: 'link',
            style: 'width:300px',
            sortable: true,
          },
          {
            name: 'ibmStepCd',
            field: 'ibmStepCd',
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:100px',
            type: 'tag',
            colorItems: _result,
            sortable: false
          },
          {
            name: 'improveRequest',
            field: 'improveRequest',
            label: '요청부서정보',
            align: 'center',
            style: 'width:250px',
            sortable: true,
          },
          {
            name: 'actionCompleteRequestDate',
            field: 'actionCompleteRequestDate',
            label: '조치완료요청일',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            label: '조치부서',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ]
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = 'LBLIMPROVE';
      this.popupOptions.param = {
        sopImprovementId: row.sopImprovementId,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>